// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-name {
  display: -webkit-box;        /* Use WebKit's box model for multiline clamping */
  -webkit-line-clamp: 2;       /* Limit the description to 4 lines */
  -webkit-box-orient: vertical;/* Specifies vertical box orientation */
  overflow: hidden;            /* Hides any overflowed content */
  text-overflow: ellipsis;     /* Displays the ellipsis when overflowed */
  font-size: 20px;
  min-height: 3em;
}

.product-description {
  margin-top:10px;
  margin-bottom:10px;
  display: -webkit-box;        /* Use WebKit's box model for multiline clamping */
  -webkit-line-clamp: 2;       /* Limit the description to 4 lines */
  -webkit-box-orient: vertical;/* Specifies vertical box orientation */
  overflow: hidden;            /* Hides overflowing content */
  text-overflow: ellipsis;     /* Displays an ellipsis when content overflows */
  min-height: 3em;
}

.card-img-top{
	border-top-right-radius: 0.375rem;
	border-top-left-radius: 0.375rem;
}

.status-label {
  position: absolute;
  top: 10px;
  left: 10px;
  color: white;
  padding: 2px 8px;
  font-size: 12px;
  border-radius: 3px;
  font-weight: bold;
  z-index: 1;
}

.status-published {
  background-color: #28a745;
}

.status-draft {
  background-color: #6c757d;
}

.setup-cave-message {
  display: none;
  position: relative;
}

.setup-cave-message.visible {
  display: block;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Products.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB,SAAS,kDAAkD;EAC/E,qBAAqB,QAAQ,qCAAqC;EAClE,4BAA4B,CAAC,uCAAuC;EACpE,gBAAgB,aAAa,iCAAiC;EAC9D,uBAAuB,MAAM,0CAA0C;EACvE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB,SAAS,kDAAkD;EAC/E,qBAAqB,QAAQ,qCAAqC;EAClE,4BAA4B,CAAC,uCAAuC;EACpE,gBAAgB,aAAa,8BAA8B;EAC3D,uBAAuB,MAAM,gDAAgD;EAC7E,eAAe;AACjB;;AAEA;CACC,iCAAiC;CACjC,gCAAgC;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".product-name {\n  display: -webkit-box;        /* Use WebKit's box model for multiline clamping */\n  -webkit-line-clamp: 2;       /* Limit the description to 4 lines */\n  -webkit-box-orient: vertical;/* Specifies vertical box orientation */\n  overflow: hidden;            /* Hides any overflowed content */\n  text-overflow: ellipsis;     /* Displays the ellipsis when overflowed */\n  font-size: 20px;\n  min-height: 3em;\n}\n\n.product-description {\n  margin-top:10px;\n  margin-bottom:10px;\n  display: -webkit-box;        /* Use WebKit's box model for multiline clamping */\n  -webkit-line-clamp: 2;       /* Limit the description to 4 lines */\n  -webkit-box-orient: vertical;/* Specifies vertical box orientation */\n  overflow: hidden;            /* Hides overflowing content */\n  text-overflow: ellipsis;     /* Displays an ellipsis when content overflows */\n  min-height: 3em;\n}\n\n.card-img-top{\n\tborder-top-right-radius: 0.375rem;\n\tborder-top-left-radius: 0.375rem;\n}\n\n.status-label {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  color: white;\n  padding: 2px 8px;\n  font-size: 12px;\n  border-radius: 3px;\n  font-weight: bold;\n  z-index: 1;\n}\n\n.status-published {\n  background-color: #28a745;\n}\n\n.status-draft {\n  background-color: #6c757d;\n}\n\n.setup-cave-message {\n  display: none;\n  position: relative;\n}\n\n.setup-cave-message.visible {\n  display: block;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
